import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-active",
  "use": "icon-home-active-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-home-active\"><defs><clipPath id=\"icon-home-active_master_svg0_92_05741\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" rx=\"0\" /></clipPath></defs><g clip-path=\"url(#icon-home-active_master_svg0_92_05741)\"><g><g></g><g><path d=\"M13.2,2.65C12.48889,2.116667,11.51111,2.116667,10.8,2.65L3.799999,7.9C3.296388,8.277709999999999,3,8.87048,3,9.5L3,19C3,20.1046,3.895431,21,5,21L8.9,21C9.50751,21,10,20.5075,10,19.9L10,15C10,13.8954,10.895430000000001,13,12,13C13.1046,13,14,13.8954,14,15L14,19.9C14,20.5075,14.4925,21,15.1,21L19,21C20.1046,21,21,20.1046,21,19L21,9.5C21,8.87049,20.7036,8.277709999999999,20.2,7.9L13.2,2.65Z\" fill=\"#6C5FFC\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-active.svg
// module id = DXxt
// module chunks = 119